import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer id="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row  justify-content-center">
            <div className="col-lg-6">
              <h3>JLAB</h3>
              <p>Elegant, creative, and intelligent engineering solutions</p>
            </div>
          </div>

          <div className="social-links">
            <a
              href="https://www.facebook.com/Jovanovski-Laboratory-1162785707196364/"
              className="facebook"
              target="_blank"
              rel="noreferrer"
            >
              <i className="bx bxl-facebook"></i>
            </a>
            <a
              href="https://www.instagram.com/jovanovskilaboratory/"
              className="instagram"
              target="_blank"
              rel="noreferrer"
            >
              <i className="bi bi-instagram"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/jovanovski-laboratory-5587a1273/"
              className="linkedin"
              target="_blank"
              rel="noreferrer"
            >
              <i className="bi bi-linkedin"></i>
            </a>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-3 col-md-4 col-sm-6 col-9">
              <p>Supported by</p>
              <img
                src="assets/img/FITD ENG Full - Black-1.png"
                className="img-fluid mt-3"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container footer-bottom clearfix">
        <div className="copyright">
          &copy; Copyright{' '}
          <strong>
            <span>JLAB</span>
          </strong>
          . All Rights Reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;
